import { Component } from '@angular/core';

@Component({
  selector: 'app-streams',
  standalone: false,
  templateUrl: './streams.component.html',
  styleUrl: './streams.component.scss'
})
export class StreamsComponent {

}
